/* eslint-disable react-hooks/exhaustive-deps */
import { MEMBER } from "actions";
import { Modal, MultiSelect } from "components/common"
import { AuthContext, CollaboratorsContext, DocumentsContext, HomeContext } from "contexts";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { GET_FILE } from 'actions/constants';
import avatar from 'assets/images/avatar.png';
import { ItemCard } from "components/pages/Organizations";
import differenceBy from 'lodash/differenceBy'
import { COGNITO_USER_ID } from 'actions';
const MEMBER_U = MEMBER.toUpperCase();

export const AssignMemberToDocument = ({ open, onCancel }) => {
    const { handleSubmit } = useForm();
    const { collaborators } = useContext(CollaboratorsContext);
    const { 
        doUpdatePartners, 
        doGetDocumentSignatureDetailVersion,
        documentDetail,
    } = useContext(DocumentsContext);
    const { 
        memberSelectedForDocument, 
        documentId, 
        setRefreshDocumentSignature, 
        idDocumentSignature,
        refreshDocumentSignature 
    } = useContext(HomeContext);
    const { userInfo } = useContext(AuthContext);
    const [memberSelected, setMemberSelected] = useState([]);
    const [arrayMembers, setArrayMembers] = useState([]);
    const inviteByEmail = 'Invite by email';
    
    useEffect(() => {
        setMemberSelected(memberSelectedForDocument.map(item => {
            return {
                email: item.email,
                id: item.id || new Date().getTime().toString(),
                icon: item.id ? (item.type === MEMBER_U ? (item.avatar ? GET_FILE + item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                title: item.id ? item?.name : item.email,
                description: item.id ? (item.type === MEMBER_U ? item.email : item.name) : inviteByEmail,
                type: item.type
            }
        }));
    }, [memberSelectedForDocument, open]);

    useEffect(() => {
        setArrayMembers(differenceBy(collaborators.map(item => {
            item.id = item._id;
            return item
        }), memberSelected, 'id').filter(x => x._id !== userInfo._id));
    }, [collaborators, memberSelected, userInfo]);

    useEffect(() => {
        if(idDocumentSignature && open) doGetDocumentSignatureDetailVersion(idDocumentSignature);
    }, [idDocumentSignature])
    
    const handleComfirm = () => {
        const partners = memberSelected.map(item => {
            return {
                id: item.id,
                type: item.type
            }
        })
        doUpdatePartners(documentId, { partners }, (data) => {
            if (data) {
                onCancel();
                setRefreshDocumentSignature(!refreshDocumentSignature);
            };
        });
        setMemberSelected([]);
    }

    const handleCancel = () => {
        setMemberSelected([]);
        onCancel();
    }

    const getMembersTeams = (index, value) => {
        setArrayMembers(differenceBy(collaborators.map(item => {
            item.id = item._id;
            return item
        }), memberSelected, 'id').filter(x => x.name.toLowerCase().includes(value)));
    }

    return (
        <Modal
            open={open}
            onCancel={handleCancel}
            title="Assign To Document"
            onCancelClick={handleCancel}
            submitButton={(documentDetail?.createdBy?.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID))}
            submitButtonLabel={"Comfirm"}
            renderForm={children => (
                <form onSubmit={handleSubmit(handleComfirm)}>
                    {children}
                </form>
            )}
        >
            {
                (documentDetail?.createdBy?.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID)) ? <>
                <MultiSelect
                    className="mbx4"
                    mode="input"
                    value={memberSelected}
                    name="shipment-admin"
                    label={"Assign To Document"}
                    options={arrayMembers.map(item => {
                        return {
                            email: item.email,
                            id: item._id || new Date().getTime().toString(),
                            icon: item._id ? (item.type === MEMBER_U ? (item.avatar ? GET_FILE + item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                            title: item._id ? item?.name : item.email,
                            description: item._id ? (item.type === MEMBER_U ? item.email : item.organization.name) : inviteByEmail,
                            type: item.type
                        }
                    })}
                    onInputChange={value => getMembersTeams(0, value)}
                    placeholder={"You can search by name, email, team name or can invite new people"}
                    onChange={items => {
                        setMemberSelected(oldData => [...oldData, ...items]);
                    }}
                    renderList={members => (   
                        <div className="tr__partners d-flex flex-wrap mtx1">
                            {members.map((member, memberIndex) => (
                                <ItemCard
                                    key={memberIndex}
                                    item={member}
                                    onRemove={item => {
                                        setMemberSelected(oldValue => [...oldValue.filter(val => val.id !== item.id)]);
                                    }}
                                    isRemovable={(documentDetail?.createdBy?.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID))}
                                    cardOnly={true}
                                />
                            ))}
                        </div>
                    )}
                />
                </> : <>
            {   
             memberSelected && memberSelected?.length && memberSelected?.map((members, index) => (
                <div className="tr__partners d-flex flex-wrap mtx1">
                        <ItemCard
                            key={index}
                            item={members}
                            onRemove={item => {
                                setMemberSelected(oldValue => [...oldValue.filter(val => val.id !== item.id)]);
                            }}
                            isRemovable={(documentDetail?.createdBy?.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID))}
                            cardOnly={true}
                        />
                </div>
            ))   
            }
            </>
        }
        </Modal>
    )
}
